// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgMusicNote = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.476 2.42a.75.75 0 0 1 .274.58v4a.75.75 0 0 1-.603.735l-4.397.88V19A2.75 2.75 0 0 1 10 21.75H9A2.75 2.75 0 0 1 6.25 19v-1A2.75 2.75 0 0 1 9 15.25h2.25V4a.75.75 0 0 1 .603-.735l5-1a.75.75 0 0 1 .622.155M11.25 16.75H9c-.69 0-1.25.56-1.25 1.25v1c0 .69.56 1.25 1.25 1.25h1c.69 0 1.25-.56 1.25-1.25zm1.5-9.665 3.5-.7v-2.47l-3.5.7z"
      clipRule="evenodd"
    />
  </svg>
);
export const MusicNoteIcon = forwardRef(SvgMusicNote);
